import { signOut } from 'next-auth/react';
import { Typography } from '@mui/material';
import { useAppDispatch } from '../../../pages/assessment';
import { updateMeta } from '../../../redux/meta';
import { Screens } from '../../../redux/types';
import { AssessmentButtons, AssessmentCard } from '../shared';

const PreviouslyCompleted = () => {
  const dispatch = useAppDispatch();
  const onClickContinue = () => dispatch(updateMeta());
  const onClickGoBack = async () => {
    await signOut({ redirect: false });
    dispatch(updateMeta({ screen: Screens.CollectEmail }));
  };

  return (
    <>
      <AssessmentCard>
        <Typography>
          We already have an assessment linked to this email. If you continue,
          you’ll overwrite your previous responses. If you’d like to preserve
          your answers or are trying to take this intake on behalf of a minor,
          please go back and use a different email.
        </Typography>
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          children: 'Continue',
          onClick: onClickContinue,
        }}
        secondary={{
          children: 'Go back',
          onClick: onClickGoBack,
        }}
      />
    </>
  );
};

export default PreviouslyCompleted;
